const hindi = {
    'navigation.about': 'के बारे में'
}
export default hindi